export enum GeometrySelectionTypes {
  Point = "select_point",
  Line = "select_line",
  Circle = "select_circle",
  Rect = "select_rect",
  Polygon = "select_polygon",
  Coordinates = "xy",
  Route = "select_route",
}

export enum GeometrySelectionToolTypes {
  Replace = "Replace",
  Unite = "Unite",
  Crop = "Crop",
  Edit = "Edit",
}
